import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import Link from "../../Link";

const WhatStocksCanBuy = ({ stocks }) => {
  const { t } = useTranslation();

  const LIMIT = 6;
  const [stockPage, setStockPage] = useState(1);

  return (
    <div className="zipstocks what-stocks-can-buy">
      <div className="container d-flex flex-column text-center">
        <h2 className="text-center">{t("zipstocks.whatStocksCanBuy.title")}</h2>
        <div className="stocks-list row justify-content-center align-self-center">
          {stocks.edges.map(({ node: { acfStockItem: stock } }, i) => (
            <div
              className={cx("col-6 col-md-4 col-lg-2 mb-4", {
                "d-none d-lg-block": i >= LIMIT * stockPage,
              })}
              key={i}
            >
              <Link className="card text-center" to={stock.link}>
                <div className="card-body">
                  <img
                    src={stock.image.localFile.publicURL}
                    alt={stock.fullName}
                  />
                  <p className="stock__full-name mt-3 mb-1">{stock.fullName}</p>
                  <p className="stock__short-name m-0">{stock.shortName}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
        {stockPage * LIMIT < stocks.edges.length && (
          <button
            className="btn_load-more d-inline-block d-lg-none button button-secondary align-self-center"
            onClick={() => setStockPage(stockPage + 1)}
          >
            {t("common.loadMore")}
          </button>
        )}
        <p className="note">{t("zipstocks.whatStocksCanBuy.note")}</p>
      </div>
    </div>
  );
};

export default WhatStocksCanBuy;
